var map = {
	"./icon_ai_brain.svg": 333,
	"./icon_brain_network.svg": 334,
	"./icon_calandar.svg": 335,
	"./icon_care.svg": 336,
	"./icon_collaboration_innovation.svg": 337,
	"./icon_dna.svg": 338,
	"./icon_dna_analysis.svg": 339,
	"./icon_doctor.svg": 340,
	"./icon_formulations.svg": 341,
	"./icon_hybrid_brain_ai.svg": 342,
	"./icon_lotion.svg": 343,
	"./icon_massage.svg": 344,
	"./icon_mental_idea.svg": 345,
	"./icon_mental_net.svg": 346,
	"./icon_mindfullness.svg": 347,
	"./icon_nutrition.svg": 348,
	"./icon_team.svg": 349,
	"./icon_world_experts.svg": 350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 332;